import PrizesTable from 'Components/Page/LandingPage/PrizesTable';
import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';

interface PopupProps {
  title: string;
  show: boolean;
  isSaymee: boolean;
  handleVisible: () => void;
}

export default function RulePopup({
  show,
  isSaymee,
  title,
  handleVisible,
}: PopupProps): JSX.Element {
  return (
    <>
      <Modal
        show={show}
        size="lg"
        onHide={() => handleVisible()}
        dialogClassName="modal-90w modal-landing customer-rule customer-button-close"
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header>
          <Modal.Title
            id="contained-modal-title-vcenter h4"
            className="text-truncate d-flex justify-content-center rule-note"
          >
            <p className="title-header mb-0 text-truncate text-header">{title}</p>
            <Button variant="" className="bt-close-modal" onClick={handleVisible}></Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="px-3 rule-note">
            <p className="text-strong py-3">1. THỜI GIAN CHƯƠNG TRÌNH</p>
            <p>- Thời gian tham gia: Từ ngày 28/7/2026 đến hết ngày 31/12/2026.</p>
            <p className="text-strong py-3">2. KHÁCH HÀNG THAM GIA</p>
            {isSaymee ? (
              <>
                <p className="ps-3">Đối với thuê bao Saymee:</p>
                <p className="ps-5">
                  + Tất cả các thuê bao trả trước Saymee đang hoạt động 01 chiều/ 02 chiều và có cập
                  nhật VLR tối thiểu 10 ngày kể từ tháng n-3 đến hết tháng n-1;
                </p>
                {/* <p className="ps-5">
              &emsp; &#10140; Trong các đối tượng này, có nhận diện thuê bao sử dụng dịch vụ chuyển
              vùng quốc tế từ 01/1/2024 đến nay để đưa ra bảng câu hỏi phù hợp.
            </p> */}
                <p className="ps-5">
                  + <b>Không</b> áp dụng cho thuê bao phục vụ test nghiệp vụ.
                </p>
              </>
            ) : (
              <>
                <p className="ps-3">
                  - Thuê bao MobiFone phát sinh tương tác trên các kênh sau được tham gia chương
                  trình: Ứng dụng My MobiFone (thực hiện các giao dịch Thanh toán/nạp tiền, Mua gói
                  cước, Đổi điểm Kết Nối Dài Lâu), Chatbot hỗ trợ khách hàng, Tổng đài hỗ trợ khách
                  hàng, Hệ thống cửa hàng và nhận được tin nhắn mời tham gia từ MobiFone.{' '}
                  <b>Loại trừ:</b>{' '}
                  <i>
                    thuê bao liên lạc nghiệp vụ, thuê bao BCA, VCA, FastConnect, M2M, MVNO, thuê bao
                    thuộc chính sách khách hàng đặc biệt.
                  </i>
                </p>
                {/* <p className="ps-5">+ Hội viên Kết Nối Dài Lâu từ hạng Kim cương đến hạng Đồng;</p>
                <p className="ps-5">+ Khách hàng thuộc mức cước từ 75.000đ trở lên.</p>
                <p className="ps-5">
                  <i>
                    {' '}
                    Lưu ý: <b>Không</b> áp dụng: thuê bao liên lạc nghiệp vụ, thuê bao BCA, VCA,
                    FastConnect, M2M, MVNO, thuê bao thuộc chính sách khách hàng đặc biệt.
                  </i>
                </p> */}
              </>
            )}

            <p className="text-strong py-3">3. CÁCH THỨC THAM GIA</p>
            {/* <p className="ps-3">
              - Sau khi hoàn tất trả lời các câu hỏi tại{' '}
              {isSaymee ? 'https://chiase.mobifone.vn/saymee' : 'https://chiase.mobifone.vn/'} hệ
              thống cho phép khách hàng tham gia quay thưởng tại chính đường dẫn này. Tương ứng với
              mỗi lượt khảo sát được ghi nhận thành công, thuê bao sẽ nhận được một mã dự thưởng để
              tham gia quay thưởng, việc quay thưởng được tiến hành trực tuyến (online) qua{' '}
              {isSaymee ? 'https://chiase.mobifone.vn/saymee' : 'https://chiase.mobifone.vn/'}
            </p>
            <p className="ps-3">
              - Trang{' '}
              {isSaymee ? 'https://chiase.mobifone.vn/saymee' : 'https://chiase.mobifone.vn/'} có
              quy định rõ về đối tượng và thể lệ tham gia chương trình khuyến mại.
            </p> */}
            <p className="ps-3">
              - Sau khi khách hàng trả lời các câu hỏi tại bảng khảo sát, hệ thống sẽ cho phép tham
              gia quay thưởng theo thể lệ của Chương trình. Đối với mỗi lượt khảo sát được hệ thống
              ghi nhận thành công, thuê bao sẽ được cấp 01 mã dự thưởng để tham gia quay thưởng.
              Việc quay thưởng được thực hiện trực tuyến (online) ngay sau khi khách hàng hoàn thành
              bảng khảo sát.
            </p>
            <p className="text-strong py-3">4. CƠ CẤU GIẢI THƯỞNG</p>
            <p>
              Tổng giá trị giải thưởng: <b>286.624.000 đồng</b>{' '}
              <i>(Bằng chữ: Hai trăm tám mươi sáu triệu sáu trăm hai tư nghìn đồng chẵn).</i>
            </p>
            <hr />
            <PrizesTable />
            <i>
              <p>Ghi chú:</p>
              <p className="ps-3">- Giá trị giải thưởng đã bao gồm thuế GTGT.</p>
              <p className="ps-3">
                - Giải nhất và Giải nhì là hiện vật, có thể quy đổi thành tiền mặt và được xác định
                trúng giải bằng hình thức quay thưởng trực tuyến.
              </p>
              <p className="ps-3">- Giải khuyến khích:</p>
              {isSaymee ? (
                <>
                  <p className="ps-5">
                    + Đối với thuê bao Saymee: dành cho 5.000 thuê bao đầu tiên tham gia chương
                    trình, trả lời đầy đủ các câu hỏi và được trao qua hình thức cộng tiền vào tài
                    khoản khuyến mại (thuê bao trả trước cộng KM1T, thuê bao trả sau cộng KM99T vào
                    các ngày 12 hàng tháng).
                  </p>
                </>
              ) : (
                <>
                  <p className="ps-5">
                    + Đối với 2.000 thuê bao đầu tiên tham gia chương trình (trả lời đầy đủ các câu
                    hỏi): cộng sản lượng 2 GB/thuê bao vào các ngày 12 hàng tháng.{' '}
                  </p>
                </>
              )}

              <p className="ps-5">
                + Đối với 8.000 thuê bao tiếp theo tham gia chương trình (trả lời đầy đủ các câu
                hỏi): cộng tiền vào tài khoản khuyến mại vào các ngày 12 hàng tháng (thuê bao trả
                trước cộng KM1T, thuê bao trả sau cộng KM99T).
              </p>
              <p className="ps-5">
                + Sản lượng 2GB/ thuê bao và KM1T, KM99T (liên lạc nội mạng MobiFone: thoại và SMS):
                hạn sử dụng 30 ngày.
              </p>
            </i>
            <p className="py-3 text-strong">5. QUY ĐỊNH VỀ BẰNG CHỨNG XÁC ĐỊNH TRÚNG THƯỞNG</p>
            <p className="ps-3">
              - Trước khi bắt đầu quay thưởng, hệ thống sẽ yêu cầu khách hàng nhập số điện thoại và
              mã dự thưởng.
            </p>
            <p className="ps-3">
              - Khách hàng có thể truy cập{' '}
              {isSaymee ? 'https://chiase.mobifone.vn/saymee' : 'https://www.mobifone.vn/chiase'} để
              tra cứu kết quả trúng thưởng.
            </p>
            <p className="ps-3">
              - Một thuê bao hoàn thành khảo sát có 01 mã quay thưởng để tham gia chương trình.
            </p>
            <p className="ps-3">
              - Tại thời điểm nhận thưởng, khách hàng trúng giải phải là chính chủ của một thuê bao
              đang hoạt động 01 chiều/02 chiều trên mạng MobiFone.
            </p>

            {/* {isSaymee ? (
              <>
                <p className="ps-3">Đối với thuê bao Saymee:</p>
                <p className="ps-5">
                  + Tất cả các thuê bao trả trước Saymee đang hoạt động 01 chiều/ 02 chiều và có cập
                  nhật VLR tối thiểu 10 ngày kể từ tháng n-3 đến hết tháng n-1;
                </p>
                <p className="ps-5">
                  + <b>Không</b> áp dụng cho thuê bao phục vụ test nghiệp vụ.
                </p>
              </>
            ) : (
              <>
                <p className="ps-3">
                  Đối với thuê bao MobiFone: Là thuê bao đang hoạt động 01 chiều/02 chiều thỏa mãn 1
                  trong 2 điều kiện:
                </p>
                <p className="ps-5">+ Hội viên Kết Nối Dài Lâu</p>
                <p className="ps-5">+ Khách hàng đạt mức cước từ 75.000đ trở lên.</p>
                <p className="ps-5">
                  <i>Lưu ý</i>: <b>Không</b> áp dụng cho thuê bao liên lạc nghiệp vụ, thuê bao BCA,
                  VCA, FastConnect, M2M, MVNO, thuê bao thuộc chính sách khách hàng đặc biệt.
                </p>
              </>
            )} */}

            <p className="py-3 text-strong">
              6. THỜI GIAN, ĐỊA ĐIỂM VÀ CÁCH THỨC XÁC ĐỊNH TRÚNG THƯỞNG
            </p>
            <p className="ps-3">
              Trong khoảng thời gian diễn ra chương trình, khách hàng trực tiếp quay thưởng trên{' '}
              {isSaymee ? 'https://chiase.mobifone.vn/saymee' : 'https://www.mobifone.vn/chiase'},
              Cụ thể:
            </p>
            <p className="ps-5">
              + Bước 1: Truy cập đường link được cấp qua một trong các phương thức đã nêu tại mục
              Hướng dẫn.
            </p>
            <p className="ps-5">+ Bước 2: Thực hiện khảo sát.</p>
            <p className="ps-5">+ Bước 3: Nhận mã dự thưởng.</p>
            <p className="ps-5">+ Bước 4: Ấn nút “Quay thưởng”.</p>
            <p className="ps-3">
              - Kết quả quay số của khách hàng được cập nhật trên{' '}
              {isSaymee ? 'https://chiase.mobifone.vn/saymee' : 'https://www.mobifone.vn/chiase'}
            </p>
            <p className="ps-3">
              - Giải thưởng tương ứng với mỗi lượt quay sẽ được lựa chọn ngẫu nhiên bởi hệ thống máy
              tính vận hành{' '}
              {isSaymee ? 'https://chiase.mobifone.vn/saymee' : 'https://www.mobifone.vn/chiase'},
              với cơ cấu giải thưởng bao gồm các giải nhất và giải nhì còn lại của chương trình.
            </p>
            <p className="py-3 text-strong">7. THỜI GIAN, ĐỊA ĐIỂM VÀ THỦ TỤC NHẬN THƯỞNG</p>
            <p className="ps-3">
              - Đối với khách hàng trúng giải khuyến khích tặng sản lượng 2GB/thuê bao và tiền vào
              tài khoản KM1T/KM99T, giải thưởng sẽ được cộng vào ngày 12 hàng tháng.
            </p>
            <p className="ps-3">
              - Đối với khách hàng trúng giải hiện vật, MobiFone sẽ liên hệ với khách hàng để xác
              minh và thông báo trúng thưởng. Khách hàng trúng thưởng tùy theo địa chỉ lưu trú, sẽ
              được Chi nhánh MobiFone hẹn trao thưởng qua điện thoại. Công ty sẽ không chịu trách
              nhiệm đối với việc khách hàng không nhận được thông báo do thay đổi số điện thoại mà
              chưa thông báo cho MobiFone.
            </p>
            <p className="ps-3">
              - Khi đến nhận thưởng, khách hàng trúng thưởng sẽ phải xuất trình các giấy tờ sau:
            </p>
            <hr />
            <Table className="table-landing-page-prizes" responsive>
              <thead>
                <tr>
                  <th>Trường hợp</th>
                  <th>Giấy tờ</th>
                  <th>Quy cách</th>
                </tr>
              </thead>
              <tbody className="table-drag-item-body">
                <tr>
                  <td rowSpan={2}>Trường hợp thuê bao đứng tên cá nhân</td>
                  <td>
                    Căn cước công dân/ căn cước vật lý còn hiệu lực hoặc ảnh thẻ căn cước điện tử
                    trong mục “Thẻ Căn cước/CCCD” trên app VNeID đã được định danh cấp 2 (có thao
                    tác mở app còn hoạt động)
                  </td>
                  <td>
                    - Đối với thẻ vật lý: 04 bản photo công chứng. <br />- Đối với thẻ điện tử: 04
                    bản chụp có chữ ký của nhân viên đối chiếu.
                  </td>
                </tr>
                <tr>
                  <td>Sim điện thoại chứa số thuê bao trúng giải</td>
                  <td>- Sim đăng ký thông tin cá nhân chính chủ của người nhận giải: 01 chiếc</td>
                </tr>
                <tr>
                  <td rowSpan={4}>Trường hợp thuê bao đứng tên cơ quan</td>
                  <td>
                    Căn cước công dân/ căn cước vật lý còn hiệu lực (hoặc ảnh thẻ căn cước điện tử
                    trong mục “Thẻ Căn cước/CCCD” trên app VNeID đã được định danh cấp 2 (có thao
                    tác mở app còn hoạt động)) của người đến làm thủ tục
                  </td>
                  <td>
                    - Đối với thẻ vật lý: 04 bản photo công chứng.
                    <br />- Đối với thẻ điện tử: 04 bản chụp có chữ ký của nhân viên đối chiếu.
                  </td>
                </tr>
                <tr>
                  <td>
                    Giấy đăng ký kinh doanh/ hoạt động hoặc tương đương của tổ chức sở hữu thuê bao
                  </td>
                  <td>- Bản photo công chứng: 04 bản.</td>
                </tr>
                <tr>
                  <td>Sim điện thoại chứa số thuê bao trúng giải</td>
                  <td></td>
                </tr>
                <tr>
                  <td>Giấy giới thiệu của cơ quan</td>
                  <td>
                    - Bản gốc: 01 bản để đối chiếu.
                    <br />- Bản photo nộp lưu hồ sơ: 04 bản.
                  </td>
                </tr>
              </tbody>
            </Table>
            <p className="ps-3">
              - Khách hàng phải có trách nhiệm chứng minh quyền chính chủ thuê bao theo đúng quy
              định. Nếu khách hàng không chứng minh được quyền chính chủ thuê bao thì MobiFone có
              quyền hủy quyền thụ hưởng của khách hàng.
            </p>
            <p className="ps-3">
              - Trong trường hợp chủ thuê bao không thể nhận giải có thể làm giấy ủy quyền có xác
              nhận của cấp có thẩm quyền cho người khác nhận thay:
            </p>
            <p className="ps-5">
              + Giấy ủy quyền đi làm thủ tục nhận giải (Bản gốc có chữ ký của người ủy quyền, người
              được ủy quyền và xác nhận của chính quyền địa phương nơi cư trú). Số lượng: 01 bản.
            </p>
            <p className="ps-5">
              + Căn cước công dân/ căn cước vật lý còn hiệu lực của người được ủy quyền (04 bản
              photo công chứng) hoặc ảnh thẻ căn cước điện tử trong mục “Thẻ Căn cước/CCCD” trên app
              VNeID đã được định danh cấp 2, có thao tác mở app còn hoạt động (04 bản chụp có chữ ký
              của nhân viên đối chiếu).
            </p>
            <p className="ps-5">
              + Các giấy tờ khác của người ủy quyền như trường hợp người đó trực tiếp làm thủ tục.
            </p>
            <p className="ps-3">
              - Sau thời hạn được MobiFone thông báo mà khách hàng trúng thưởng không đến nhận giải
              thưởng sẽ mất quyền nhận thưởng, giải thưởng sẽ được xử lý trong trường hợp không có
              người trúng thưởng.
            </p>
            <p className="py-3 text-strong">8. TRÁCH NHIỆM THÔNG BÁO</p>
            <p className="ps-3">
              - Tổng công ty Viễn thông MobiFone có trách nhiệm thông báo đầy đủ chi tiết nội dung
              của thể lệ chương trình khuyến mại, trị giá giải thưởng, cách thức xác định khách hàng
              trúng thưởng… trên website:{' '}
              {isSaymee ? 'https://chiase.mobifone.vn/saymee' : 'https://www.mobifone.vn/chiase'}.
            </p>
            <p className="ps-3">
              - Tổng công ty Viễn thông MobiFone sẽ thông báo đầy đủ danh sách khách hàng trúng
              thưởng trên ít nhất 01 phương tiện thông tin đại chúng và trên website{' '}
              {isSaymee ? 'https://chiase.mobifone.vn/saymee' : 'https://www.mobifone.vn/chiase'}.
              Khách hàng trúng giải sẽ được MobiFone thông báo trực tiếp qua điện thoại, nhắn tin
              hoặc một hình thức liên hệ phù hợp khác trong thời hạn 07 ngày kể từ ngày quay số
              trúng thưởng.
            </p>
            <p className="py-3 text-strong">9. QUY ĐỊNH KHÁC</p>
            <p className="ps-3">
              - Các trường hợp tham gia chương trình không đúng theo các bước được hướng dẫn ở trên
              được xem là không hợp lệ và MobiFone có quyền từ chối kết quả của người tham gia đó mà
              không cần báo trước.
            </p>
            <p className="ps-3">
              - Nếu người trúng thưởng còn nợ MobiFone bất kỳ số tiền nào thì số tiền nợ đó phải
              được thanh toán trước thời điểm trao thưởng. Nếu số tiền nợ đó không được thanh toán,
              người trúng thưởng sẽ bị tước giải thưởng.
            </p>
            <p className="ps-3 text-align-last-justify">
              - Khách hàng trúng thưởng phải chịu chi phí đi lại cho việc nhận thưởng của mình và
              thuế thu nhập không thường xuyên (nếu có) theo quy định của pháp luật Việt Nam
              <p className="text-align-last-left">hiện hành. </p>
            </p>
            <p className="ps-3 text-align-last-justify">
              - Nếu được khách hàng trúng thưởng đồng ý, Tổng công ty Viễn thông MobiFone sẽ sử dụng
              tên và hình ảnh của khách hàng trúng thưởng cho mục đích quảng cáo
              <p className="text-align-last-left">thương mại. </p>
            </p>
            <p className="ps-3">
              - Nghiêm cấm những trường hợp lợi dụng lỗi dịch vụ, gian lận và sử dụng phần mềm để
              gây rối, điều chỉnh hoặc can thiệp vào kết quả của CTKM. Nếu phát hiện ra người tham
              gia gian lận hoặc có dấu hiệu gian lận, MobiFone có quyền từ chối kết quả của người
              tham gia đó mà không cần báo trước.
            </p>
            <p className="ps-3">
              - Trong trường hợp xảy ra tranh chấp liên quan đến chương trình khuyến mại này, Tổng
              công ty Viễn thông MobiFone có trách nhiệm trực tiếp giải quyết, nếu không thỏa thuận
              được tranh chấp sẽ được xử lý theo quy định của pháp luật Việt Nam hiện hành.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column px-5 pb-4">
          <Button variant="danger fs-18 rounded-pill text-bold" onClick={() => handleVisible()}>
            Đóng lại
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
